//
//
//
//
//
//
//
//
//

import _ from 'lodash';

export default {
    props : {
        items : {
            type : Object,
            required : true
        }
    },
    data : function () {
        return {
            dropdown_open : false,
            current_selection : Object.keys(this.items)[0]
        };
    },
    methods : {
    }
}



// WEBPACK FOOTER //
// ./js/vue/dropdown.vue